<template>
  <div class="success">
    <img src="@/assets/image/yes.png" alt="" />
    <div class="title">{{ title }}</div>
    <!-- <van-button @click="handleNext" style="margin-top: 20px;" round block type="info">
      {{ btnTitle }}
    </van-button> -->
  </div>
</template>

<script>
// 密码找回1
export default {
  data() {
    return {
      type: 0,
      title: '',
      btnTitle: ''
    }
  },
  created() {
    this.type = this.$route.query.type
    switch (this.type) {
      case '1':
        this.title = '密码找回成功'
        this.btnTitle = '去登陆'
        break
      case '2':
        this.title = '密码重置成功'
        this.btnTitle = '去登陆'
        break
      case '3':
        this.title = '恭喜您，注册成功'
        this.btnTitle = '去登陆'
        break
    }
    this.handleNext()
  },
  methods: {
    handleNext() {
      setTimeout(() => {
        this.$router.replace('/login')
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
.success {
  height: 100vh;
  padding: 20px;
  overflow: hidden;
  background: #fff;
  img {
    width: 50px;
    height: 50px;
    display: block;
    margin: 72px auto 0;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #1a1a1a;
    text-align: center;
    line-height: 2;
    margin-top: 20px;
  }
}
</style>
